import React from 'react';
import { LuCircleAlert } from 'react-icons/lu';

const ErrorAlert = ({ message }) => {
  return (
    <div className="bg-red-50 border-l-4 border-red-400 p-4 my-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <LuCircleAlert className="h-5 w-5 text-red-400" />
        </div>
        <div className="ml-3">
          <p className="text-sm text-red-700">
            {message || 'An unexpected error occurred. Please try again later.'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ErrorAlert; 
